/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2021. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  linkAccountPageTitle: {
    id: 'Link_Account_Title',
    defaultMessage: 'Link my account',
  },
  statement: {
    id: 'Link_Account_Statement',
    defaultMessage:
      'Are you receiving benefits from South Dakota Economic Assistance or have you in the past? If so, you can use SD BEES to manage your benefits online, anytime. Simply complete the form below to submit a request to link your SD BEES account to your case information.',
  },
  thingsYouCanDoStatement: {
    id: 'Link_Account_ThingsYouCanDoStatement',
    defaultMessage: "Things You'll Be Able To Do:",
  },
  thingsYouCanDo1: {
    id: 'Link_Account_ThingsYouCanDo1',
    defaultMessage: 'View the status of your coverage',
  },
  thingsYouCanDo2: {
    id: 'Link_Account_ThingsYouCanDo2',
    defaultMessage: 'Renew your benefits',
  },
  thingsYouCanDo3: {
    id: 'Link_Account_ThingsYouCanDo3',
    defaultMessage: 'Report changes - income, household members, expenses or address',
  },
  thingsYouCanDo4: {
    id: 'Link_Account_ThingsYouCanDo4',
    defaultMessage: 'Upload verifications',
  },
  thingsYouCanDo5: {
    id: 'Link_Account_ThingsYouCanDo5',
    defaultMessage: 'View notices',
  },
  hasExistingBenefits: {
    id: 'Link_Account_HasExistingBenefits',
    defaultMessage:
      'Do you have a pending application or have you ever received South Dakota Economic Assistance Benefits?',
  },
  mpi: {
    id: 'Link_Account_MPI',
    defaultMessage: 'What is your Case Number?',
  },
  blankCaseNumber: {
    id: 'Link_Account_BlankCaseNumber',
    defaultMessage: 'Please enter your case number',
  },
  nonexistantCaseNumber: {
    id: 'Link_Account_NonexistantCaseNumber',
    defaultMessage:
      'We do not have a record of this case number. Please ensure you have enterred your number in correctly.',
  },
  attachProof: {
    id: 'Link_Account_AttachProof',
    defaultMessage:
      "Upload a proof of your identity, such as a copy of your driver's license, your voting card, or any other identification document.",
  },
  blankRecipient: {
    id: 'Link_Account_BlankRecipient',
    defaultMessage: 'Please select an answer',
  },
  notARecipient: {
    id: 'Link_Account_NotARecipient',
    defaultMessage:
      'Your request cannot be submitted because you have not applied for benefits and/or are not a current or former recipient of South Dakota Economic Assistance Benefits.',
  },
  benefitRecipientPlaceholder: {
    id: 'Link_Account_IsBenefitRecipientPlaceholder',
    defaultMessage: ' ',
  },
  submit: {
    id: 'Link_Account_Submit',
    defaultMessage: 'Submit',
  },
  browse: {
    id: 'Link_Account_Browse',
    defaultMessage: 'Browse...',
  },
  errorFileToBig: {
    id: 'Link_Account_Error_FileToBigMessage',
    defaultMessage: 'Your file must be under {maxSize} MB in size.',
  },
  errorWrongExtension: {
    id: 'Link_Account_Error_WrongExtension',
    defaultMessage: 'Your file must be in {allowedExtensions} format',
  },
  // BEGIN PR-12848 ZPK - Back link text
  back: {
    id: 'Link_Account_Back',
    defaultMessage: 'Back',
  },
  // END PR-12848 ZPK - Back link text
});
